import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';

export default function EmailingLayout() {
  const loc = useLocation();
  if (loc.pathname === '/emailing' || loc.pathname === '/emailing/') {
    return <Navigate to="/emailing/campagnes" replace />;
  }
  return <Outlet />;
}
